import InterTtf from '../fonts/inter/Inter-AllStyles.ttf';
import InterWoff2 from '../fonts/inter/Inter-AllStyles.woff2';

interface FontFace {
  fontFamily: string;
  fontStyle: string;
  fontWeight: string;
  fontDisplay: string;
  src: string;
}

/**
 * Inter variable font — a single @font-face with a weight range (200–700)
 * so the browser downloads the file exactly once, regardless of how many
 * weights the page uses simultaneously.
 * WOFF2 is preferred; TTF is retained as a fallback for older clients.
 */
const INTER_FONT_FAMILY = 'Inter';
const INTER_SRC = `url('${InterWoff2}') format('woff2'), url('${InterTtf}') format('truetype')`;

/**
 * The font stack applied to every typography variant and component override.
 * Inter is a variable font, so all weights share one family name and only
 * `fontWeight` distinguishes them — the stack itself never varies.
 */
export const FONT_STACK = `${INTER_FONT_FAMILY}, "Open Sans", Arial, sans-serif`;

/**
 * Single @font-face registration covering all weights.
 * Use this in MuiCssBaseline styleOverrides to register the font.
 */
export const interFontFace: FontFace = {
  fontFamily: INTER_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: '200 700',
  fontDisplay: 'swap',
  src: INTER_SRC,
};

/**
 * Per-weight references used by typography tokens in BDTheme.styles.ts.
 * These are NOT registered as separate @font-face rules — only interFontFace is.
 */
export const interLight: FontFace = {
  fontFamily: INTER_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: '200',
  fontDisplay: 'swap',
  src: INTER_SRC,
};

export const interRegular: FontFace = {
  fontFamily: INTER_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: '400',
  fontDisplay: 'swap',
  src: INTER_SRC,
};

export const interMedium: FontFace = {
  fontFamily: INTER_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: '500',
  fontDisplay: 'swap',
  src: INTER_SRC,
};

export const interSemibold: FontFace = {
  fontFamily: INTER_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: '600',
  fontDisplay: 'swap',
  src: INTER_SRC,
};

export const interBold: FontFace = {
  fontFamily: INTER_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: '700',
  fontDisplay: 'swap',
  src: INTER_SRC,
};
